var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Heading'),_c('v-row',{staticClass:"mx-4",attrs:{"justify":"center"}},[_c('BrandSelect',{on:{"brand":_vm.setBrand}}),_c('v-col',{attrs:{"md":"1"}}),_c('EcuSelect',{ref:"ecu"})],1),_c('SearchBtn',{on:{"click":_vm.onClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }